module.exports = __webpack_public_path__ + "files/0ea17f769aa2b208d5f12fd7d53130aa.png";